import React, { useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { leadsData } from "../../core/data/json/leads";
import { Modal } from "react-bootstrap";
import { TableData } from "../../core/data/interface";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import CollapseHeader from "../../core/common/collapse-header";
import { SelectWithImage2 } from "../../core/common/selectWithImage2";
import { all_routes } from "../router/all_routes";
import { TagsInput } from "react-tag-input-component";
import Offcanvas from "react-bootstrap/Offcanvas";
import Slider from "rc-slider";
const VoiceRinglessTemplate = () => {
  const route = all_routes;
  const [adduser, setAdduser] = useState(false);
  const [addcompany, setAddCompany] = useState(false);
  const [modalTitle, setModalTitle] = useState("Add New Lead");
  const data = leadsData;
  const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose2 = () => setShow(false);
  const handleShow2 = () => setShow(true);
  const handleClose3 = () => setShow(false);
  const handleShow3 = () => setShow(true);
  const togglePopup = (isEditing: any) => {
    setModalTitle(isEditing ? "Edit Lead" : "Add New Lead");
    setAdduser(!adduser);
  };
  const addcompanyPopup = () => {
    setAddCompany(!addcompany);
  };

  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const columns = [
    {
      title: "",
      dataIndex: "",
    },
    {
      title: "Description",
      dataIndex: "lead_name",
      key: "lead_name",
      render: (text: any) => (
        <Link to="#" className="title-name">
          {text}
        </Link>
      ),
      sorter: (a: TableData, b: TableData) =>
        a.lead_name.length - b.lead_name.length,
    },
    {
      title: "File Name",
      dataIndex: "",
      key: "",
      sorter: true,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-target="#offcanvas_edit"
              data-bs-toggle="offcanvas"
            >
              <i className="ti ti-edit text-blue" /> Edit
            </Link>

            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_lead"
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const initialSettings = {
    endDate: new Date("2020-08-11T12:30:00.000Z"),
    ranges: {
      "Last 30 Days": [
        new Date("2020-07-12T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last 7 Days": [
        new Date("2020-08-04T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last Month": [
        new Date("2020-06-30T18:30:00.000Z"),
        new Date("2020-07-31T18:29:59.999Z"),
      ],
      "This Month": [
        new Date("2020-07-31T18:30:00.000Z"),
        new Date("2020-08-31T18:29:59.999Z"),
      ],
      Today: [
        new Date("2020-08-10T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      Yesterday: [
        new Date("2020-08-09T04:57:17.076Z"),
        new Date("2020-08-09T04:57:17.076Z"),
      ],
    },
    startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
    timePicker: false,
  };
  const [newContents, setNewContents] = useState<number[]>([0]);

  const addNewContent = () => {
    setNewContents([...newContents, newContents.length]);
  };

  const currency = [
    { value: "Choose", label: "Choose" },
    { value: "Dollar", label: "Dollar" },
    { value: "Euro", label: "Euro" },
    { value: "Pound", label: "Pound" },
    { value: "Rupee", label: "Rupee" },
  ];
  const [method, setMethod] = useState<"upload" | "convert">("upload");
  const [text, setText] = useState(
    "Hello, We are running a Caller ID name test for this number."
  );

  const [speed, setSpeed] = useState(50); // Initial value for Speed
  const [pitch, setPitch] = useState(50); // Initial value for Pitch

  const handleSpeedChange = (value: number | number[]) => {
    setSpeed(Array.isArray(value) ? value[0] : value);
  };

  const handlePitchChange = (value: number | number[]) => {
    setPitch(Array.isArray(value) ? value[0] : value);
  };
  const [voice, setVoice] = useState("en-US-Neural2-E (FEMALE)");

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">Ringless Voice Template</h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center">
                      <div className="col-sm-4">
                        <div className="icon-form mb-3 mb-sm-0">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                          />
                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          <Link
                            to="#"
                            data-bs-target="#offcanvas_add"
                            data-bs-toggle="offcanvas"
                            className="btn btn-primary"
                            onClick={handleShow2}
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                            Add
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* /Search */}
                  </div>
                  <div className="card-body">
                    {/* Contact List */}
                    <div className="row ">
                      <div className="table-responsive custom-table">
                        <Table dataSource={data} columns={columns} />
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="datatable-length" />
                      </div>
                      <div className="col-md-6">
                        <div className="datatable-paginate" />
                      </div>
                    </div>
                    {/* /Contact List */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}

        {/* Add Company */}
        <div
          className="offcanvas"
          style={{ width: "1150px", right: "0", top: "0" }}
          tabIndex={-1}
          id="offcanvas_add"
        >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">Ringless Voice Template</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="offcanvas-body">
            <div className="row">
              {/* Audio File Description */}
              <div className="col-md-6 mb-4">
                <div className="mb-3">
                  <label className="col-form-label">
                    Audio File Description{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="input-group mb-3">
                    <span className="input-group-text">
                      <i className="ti-user"></i>
                    </span>
                    <input
                      type="text"
                      value="IVR DESC"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              {/* Method Selection */}
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">Method</label>
                  <div className="d-flex align-items-center">
                    <div className="me-2">
                      <input
                        type="radio"
                        className="status-radio"
                        id="uploadFile"
                        name="method"
                        checked={method === "upload"}
                        onChange={() => setMethod("upload")}
                      />
                      <label htmlFor="uploadFile">Upload File</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        className="status-radio"
                        id="convertText"
                        name="method"
                        checked={method === "convert"}
                        onChange={() => setMethod("convert")}
                      />
                      <label htmlFor="convertText">Convert Text to Audio</label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Upload File Section */}
              {method === "upload" && (
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="profile-upload">
                      <div className="profile-upload-img">
                        <span>
                          <i className="ti ti-photo" />
                        </span>
                        <ImageWithBasePath
                          src="assets/img/profiles/avatar-20.jpg"
                          alt="img"
                          className="preview1"
                        />
                        <button type="button" className="profile-remove">
                          <i className="ti ti-x" />
                        </button>
                      </div>
                      <div className="profile-upload-content">
                        <label className="profile-upload-btn">
                          <i className="ti ti-file-broken" /> Upload File
                          <input type="file" className="input-img" />
                        </label>
                        <p>(Only mp3 or wav file type is allowed)</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Convert Text to Audio Section */}
              {method === "convert" && (
                <div className="row">
                  <div className="row mb-3">
                    <div className="mb-3 col-md-6">
                      <div className="form-group">
                        <label className="form-label">Language</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ti-user"></i>
                          </span>
                          <select
                            id="language_ddl"
                            name="language"
                            className="form-select"
                          >
                            <option value="QWZyaWthYW5zIChTb3V0aCBBZnJpY2Ep">
                              Afrikaans (South Africa)
                            </option>
                            <option value="QXJhYmlj">Arabic</option>
                            <option value="QmVuZ2FsaSAoSW5kaWEp">
                              Bengali (India)
                            </option>
                            <option value="QnVsZ2FyaWFuIChCdWxnYXJpYSk=">
                              Bulgarian (Bulgaria)
                            </option>
                            <option value="Q2F0YWxhbiAoU3BhaW4p">
                              Catalan (Spain)
                            </option>
                            <option value="Q2hpbmVzZSAoSG9uZyBLb25nKQ==">
                              Chinese (Hong Kong)
                            </option>
                            <option value="Q3plY2ggKEN6ZWNoIFJlcHVibGljKQ==">
                              Czech (Czech Republic)
                            </option>
                            <option value="RGFuaXNoIChEZW5tYXJrKQ==">
                              Danish (Denmark)
                            </option>
                            <option value="RHV0Y2ggKE5ldGhlcmxhbmRzKQ==">
                              Dutch (Netherlands)
                            </option>
                            <option value="RW5nbGlzaCAoQXVzdHJhbGlhKQ==">
                              English (Australia)
                            </option>
                            <option value="RW5nbGlzaCAoSW5kaWEp">
                              English (India)
                            </option>
                            <option value="RW5nbGlzaCAoVUsp">
                              English (UK)
                            </option>
                            <option value="RW5nbGlzaCAoVVMp">
                              English (US)
                            </option>
                            <option value="RmlsaXBpbm8gKFBoaWxpcHBpbmVzKQ==">
                              Filipino (Philippines)
                            </option>
                            <option value="RmlubmlzaCAoRmlubGFuZCk=">
                              Finnish (Finland)
                            </option>
                            <option value="RnJlbmNoIChDYW5hZGEp">
                              French (Canada)
                            </option>
                            <option value="RnJlbmNoIChGcmFuY2Up">
                              French (France)
                            </option>
                            <option value="R2VybWFuIChHZXJtYW55KQ==">
                              German (Germany)
                            </option>
                            <option value="R3JlZWsgKEdyZWVjZSk=">
                              Greek (Greece)
                            </option>
                            <option value="R3VqYXJhdGkgKEluZGlhKQ==">
                              Gujarati (India)
                            </option>
                            <option value="SGluZGkgKEluZGlhKQ==">
                              Hindi (India)
                            </option>
                            <option value="SHVuZ2FyaWFuIChIdW5nYXJ5KQ==">
                              Hungarian (Hungary)
                            </option>
                            <option value="SWNlbGFuZGljIChJY2VsYW5kKQ==">
                              Icelandic (Iceland)
                            </option>
                            <option value="SW5kb25lc2lhbiAoSW5kb25lc2lhKQ==">
                              Indonesian (Indonesia)
                            </option>
                            <option value="SXRhbGlhbiAoSXRhbHkp">
                              Italian (Italy)
                            </option>
                            <option value="SmFwYW5lc2UgKEphcGFuKQ==">
                              Japanese (Japan)
                            </option>
                            <option value="S2FubmFkYSAoSW5kaWEp">
                              Kannada (India)
                            </option>
                            <option value="S29yZWFuIChTb3V0aCBLb3JlYSk=">
                              Korean (South Korea)
                            </option>
                            <option value="TGF0dmlhbiAoTGF0dmlhKQ==">
                              Latvian (Latvia)
                            </option>
                            <option value="TWFsYXlhbGFtIChJbmRpYSk=">
                              Malayalam (India)
                            </option>
                            <option value="TWFuZGFyaW4gQ2hpbmVzZQ==">
                              Mandarin Chinese
                            </option>
                            <option value="Tm9yd2VnaWFuIChOb3J3YXkp">
                              Norwegian (Norway)
                            </option>
                            <option value="UG9saXNoIChQb2xhbmQp">
                              Polish (Poland)
                            </option>
                            <option value="UG9ydHVndWVzZSAoQnJhemlsKQ==">
                              Portuguese (Brazil)
                            </option>
                            <option value="UG9ydHVndWVzZSAoUG9ydHVnYWwp">
                              Portuguese (Portugal)
                            </option>
                            <option value="Um9tYW5pYW4gKFJvbWFuaWEp">
                              Romanian (Romania)
                            </option>
                            <option value="UnVzc2lhbiAoUnVzc2lhKQ==">
                              Russian (Russia)
                            </option>
                            <option value="U2VyYmlhbiAoQ3lyaWxsaWMp">
                              Serbian (Cyrillic)
                            </option>
                            <option value="U2xvdmFrIChTbG92YWtpYSk=">
                              Slovak (Slovakia)
                            </option>
                            <option value="U3BhbmlzaCAoU3BhaW4p">
                              Spanish (Spain)
                            </option>
                            <option value="U3BhbmlzaCAoVVMp">
                              Spanish (US)
                            </option>
                            <option value="U3dlZGlzaCAoU3dlZGVuKQ==">
                              Swedish (Sweden)
                            </option>
                            <option value="VGFtaWwgKEluZGlhKQ==">
                              Tamil (India)
                            </option>
                            <option value="VGVsdWd1IChJbmRpYSk=">
                              Telugu (India)
                            </option>
                            <option value="VGhhaSAoVGhhaWxhbmQp">
                              Thai (Thailand)
                            </option>
                            <option value="VHVya2lzaCAoVHVya2V5KQ==">
                              Turkish (Turkey)
                            </option>
                            <option value="VWtyYWluaWFuIChVa3JhaW5lKQ==">
                              Ukrainian (Ukraine)
                            </option>
                            <option value="VmlldG5hbWVzZSAoVmlldG5hbSk=">
                              Vietnamese (Vietnam)
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3 col-md-6">
                      <div className="form-group">
                        <label className="form-label">Voice Name</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ti-user"></i>
                          </span>
                          <select
                            id="voice_name_ddl"
                            name="voice_name"
                            className="form-select"
                          >
                            <option value="en-US ## en-US-Neural2-A ## MALE">
                              en-US-Neural2-A (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-C ## FEMALE">
                              en-US-Neural2-C (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-D ## MALE">
                              en-US-Neural2-D (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-E ## FEMALE">
                              en-US-Neural2-E (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-F ## FEMALE">
                              en-US-Neural2-F (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-G ## FEMALE">
                              en-US-Neural2-G (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-H ## FEMALE">
                              en-US-Neural2-H (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-I ## MALE">
                              en-US-Neural2-I (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-J ## MALE">
                              en-US-Neural2-J (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-A ## MALE">
                              en-US-Wavenet-A (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-B ## MALE">
                              en-US-Wavenet-B (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-C ## FEMALE">
                              en-US-Wavenet-C (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-D ## MALE">
                              en-US-Wavenet-D (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-E ## FEMALE">
                              en-US-Wavenet-E (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-F ## FEMALE">
                              en-US-Wavenet-F (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-G ## FEMALE">
                              en-US-Wavenet-G (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-H ## FEMALE">
                              en-US-Wavenet-H (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-I ## MALE">
                              en-US-Wavenet-I (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-J ## MALE">
                              en-US-Wavenet-J (MALE){" "}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div>
                        <label className="form-label">Speed</label>
                        <Slider value={speed} onChange={handleSpeedChange} />
                        {speed}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div>
                        <label className="form-label">Pitch</label>
                        <Slider value={pitch} onChange={handlePitchChange} />
                        {pitch}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-10 mb-3">
                      <label className="form-label">Text to Convert</label>
                      <textarea
                        className="form-control"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                      />
                    </div>
                    <div className="col-md-2 mb-3 d-flex align-items-center justify-content-end">
                      <button   type="button"
                  data-bs-dismiss="offcanvas" className="btn btn-primary">Listen</button>
                    </div>
                  </div>
                </div>
              )}

              {/* Buttons */}
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setOpenModal(true)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* /Add Company */}

        {/* Edit User */}
        <div
          className="offcanvas"
          style={{ width: "1150px", right: "0", top: "0" }}
          tabIndex={-1}
          id="offcanvas_edit"
        >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold"> Edit Ringless Voice Template</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="offcanvas-body">
            <div className="row">
              {/* Audio File Description */}
              <div className="col-md-6 mb-4">
                <div className="mb-3">
                  <label className="col-form-label">
                    Audio File Description{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="input-group mb-3">
                    <span className="input-group-text">
                      <i className="ti-user"></i>
                    </span>
                    <input
                      type="text"
                      value="IVR DESC"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              {/* Method Selection */}
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">Method</label>
                  <div className="d-flex align-items-center">
                    <div className="me-2">
                      <input
                        type="radio"
                        className="status-radio"
                        id="uploadFile"
                        name="method"
                        checked={method === "upload"}
                        onChange={() => setMethod("upload")}
                      />
                      <label htmlFor="uploadFile">Upload File</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        className="status-radio"
                        id="convertText"
                        name="method"
                        checked={method === "convert"}
                        onChange={() => setMethod("convert")}
                      />
                      <label htmlFor="convertText">Convert Text to Audio</label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Upload File Section */}
              {method === "upload" && (
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="profile-upload">
                      <div className="profile-upload-img">
                        <span>
                          <i className="ti ti-photo" />
                        </span>
                        <ImageWithBasePath
                          src="assets/img/profiles/avatar-20.jpg"
                          alt="img"
                          className="preview1"
                        />
                        <button type="button" className="profile-remove">
                          <i className="ti ti-x" />
                        </button>
                      </div>
                      <div className="profile-upload-content">
                        <label className="profile-upload-btn">
                          <i className="ti ti-file-broken" /> Upload File
                          <input type="file" className="input-img" />
                        </label>
                        <p>(Only mp3 or wav file type is allowed)</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Convert Text to Audio Section */}
              {method === "convert" && (
                <div className="row">
                  <div className="row mb-3">
                    <div className="mb-3 col-md-6">
                      <div className="form-group">
                        <label className="form-label">Language</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ti-user"></i>
                          </span>
                          <select
                            id="language_ddl"
                            name="language"
                            className="form-select"
                          >
                            <option value="QWZyaWthYW5zIChTb3V0aCBBZnJpY2Ep">
                              Afrikaans (South Africa)
                            </option>
                            <option value="QXJhYmlj">Arabic</option>
                            <option value="QmVuZ2FsaSAoSW5kaWEp">
                              Bengali (India)
                            </option>
                            <option value="QnVsZ2FyaWFuIChCdWxnYXJpYSk=">
                              Bulgarian (Bulgaria)
                            </option>
                            <option value="Q2F0YWxhbiAoU3BhaW4p">
                              Catalan (Spain)
                            </option>
                            <option value="Q2hpbmVzZSAoSG9uZyBLb25nKQ==">
                              Chinese (Hong Kong)
                            </option>
                            <option value="Q3plY2ggKEN6ZWNoIFJlcHVibGljKQ==">
                              Czech (Czech Republic)
                            </option>
                            <option value="RGFuaXNoIChEZW5tYXJrKQ==">
                              Danish (Denmark)
                            </option>
                            <option value="RHV0Y2ggKE5ldGhlcmxhbmRzKQ==">
                              Dutch (Netherlands)
                            </option>
                            <option value="RW5nbGlzaCAoQXVzdHJhbGlhKQ==">
                              English (Australia)
                            </option>
                            <option value="RW5nbGlzaCAoSW5kaWEp">
                              English (India)
                            </option>
                            <option value="RW5nbGlzaCAoVUsp">
                              English (UK)
                            </option>
                            <option value="RW5nbGlzaCAoVVMp">
                              English (US)
                            </option>
                            <option value="RmlsaXBpbm8gKFBoaWxpcHBpbmVzKQ==">
                              Filipino (Philippines)
                            </option>
                            <option value="RmlubmlzaCAoRmlubGFuZCk=">
                              Finnish (Finland)
                            </option>
                            <option value="RnJlbmNoIChDYW5hZGEp">
                              French (Canada)
                            </option>
                            <option value="RnJlbmNoIChGcmFuY2Up">
                              French (France)
                            </option>
                            <option value="R2VybWFuIChHZXJtYW55KQ==">
                              German (Germany)
                            </option>
                            <option value="R3JlZWsgKEdyZWVjZSk=">
                              Greek (Greece)
                            </option>
                            <option value="R3VqYXJhdGkgKEluZGlhKQ==">
                              Gujarati (India)
                            </option>
                            <option value="SGluZGkgKEluZGlhKQ==">
                              Hindi (India)
                            </option>
                            <option value="SHVuZ2FyaWFuIChIdW5nYXJ5KQ==">
                              Hungarian (Hungary)
                            </option>
                            <option value="SWNlbGFuZGljIChJY2VsYW5kKQ==">
                              Icelandic (Iceland)
                            </option>
                            <option value="SW5kb25lc2lhbiAoSW5kb25lc2lhKQ==">
                              Indonesian (Indonesia)
                            </option>
                            <option value="SXRhbGlhbiAoSXRhbHkp">
                              Italian (Italy)
                            </option>
                            <option value="SmFwYW5lc2UgKEphcGFuKQ==">
                              Japanese (Japan)
                            </option>
                            <option value="S2FubmFkYSAoSW5kaWEp">
                              Kannada (India)
                            </option>
                            <option value="S29yZWFuIChTb3V0aCBLb3JlYSk=">
                              Korean (South Korea)
                            </option>
                            <option value="TGF0dmlhbiAoTGF0dmlhKQ==">
                              Latvian (Latvia)
                            </option>
                            <option value="TWFsYXlhbGFtIChJbmRpYSk=">
                              Malayalam (India)
                            </option>
                            <option value="TWFuZGFyaW4gQ2hpbmVzZQ==">
                              Mandarin Chinese
                            </option>
                            <option value="Tm9yd2VnaWFuIChOb3J3YXkp">
                              Norwegian (Norway)
                            </option>
                            <option value="UG9saXNoIChQb2xhbmQp">
                              Polish (Poland)
                            </option>
                            <option value="UG9ydHVndWVzZSAoQnJhemlsKQ==">
                              Portuguese (Brazil)
                            </option>
                            <option value="UG9ydHVndWVzZSAoUG9ydHVnYWwp">
                              Portuguese (Portugal)
                            </option>
                            <option value="Um9tYW5pYW4gKFJvbWFuaWEp">
                              Romanian (Romania)
                            </option>
                            <option value="UnVzc2lhbiAoUnVzc2lhKQ==">
                              Russian (Russia)
                            </option>
                            <option value="U2VyYmlhbiAoQ3lyaWxsaWMp">
                              Serbian (Cyrillic)
                            </option>
                            <option value="U2xvdmFrIChTbG92YWtpYSk=">
                              Slovak (Slovakia)
                            </option>
                            <option value="U3BhbmlzaCAoU3BhaW4p">
                              Spanish (Spain)
                            </option>
                            <option value="U3BhbmlzaCAoVVMp">
                              Spanish (US)
                            </option>
                            <option value="U3dlZGlzaCAoU3dlZGVuKQ==">
                              Swedish (Sweden)
                            </option>
                            <option value="VGFtaWwgKEluZGlhKQ==">
                              Tamil (India)
                            </option>
                            <option value="VGVsdWd1IChJbmRpYSk=">
                              Telugu (India)
                            </option>
                            <option value="VGhhaSAoVGhhaWxhbmQp">
                              Thai (Thailand)
                            </option>
                            <option value="VHVya2lzaCAoVHVya2V5KQ==">
                              Turkish (Turkey)
                            </option>
                            <option value="VWtyYWluaWFuIChVa3JhaW5lKQ==">
                              Ukrainian (Ukraine)
                            </option>
                            <option value="VmlldG5hbWVzZSAoVmlldG5hbSk=">
                              Vietnamese (Vietnam)
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3 col-md-6">
                      <div className="form-group">
                        <label className="form-label">Voice Name</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ti-user"></i>
                          </span>
                          <select
                            id="voice_name_ddl"
                            name="voice_name"
                            className="form-select"
                          >
                            <option value="en-US ## en-US-Neural2-A ## MALE">
                              en-US-Neural2-A (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-C ## FEMALE">
                              en-US-Neural2-C (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-D ## MALE">
                              en-US-Neural2-D (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-E ## FEMALE">
                              en-US-Neural2-E (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-F ## FEMALE">
                              en-US-Neural2-F (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-G ## FEMALE">
                              en-US-Neural2-G (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-H ## FEMALE">
                              en-US-Neural2-H (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-I ## MALE">
                              en-US-Neural2-I (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Neural2-J ## MALE">
                              en-US-Neural2-J (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-A ## MALE">
                              en-US-Wavenet-A (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-B ## MALE">
                              en-US-Wavenet-B (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-C ## FEMALE">
                              en-US-Wavenet-C (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-D ## MALE">
                              en-US-Wavenet-D (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-E ## FEMALE">
                              en-US-Wavenet-E (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-F ## FEMALE">
                              en-US-Wavenet-F (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-G ## FEMALE">
                              en-US-Wavenet-G (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-H ## FEMALE">
                              en-US-Wavenet-H (FEMALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-I ## MALE">
                              en-US-Wavenet-I (MALE){" "}
                            </option>
                            <option value="en-US ## en-US-Wavenet-J ## MALE">
                              en-US-Wavenet-J (MALE){" "}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div>
                        <label className="form-label">Speed</label>
                        <Slider value={speed} onChange={handleSpeedChange} />
                        {speed}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div>
                        <label className="form-label">Pitch</label>
                        <Slider value={pitch} onChange={handlePitchChange} />
                        {pitch}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-10 mb-3">
                      <label className="form-label">Text to Convert</label>
                      <textarea
                        className="form-control"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                      />
                    </div>
                    <div className="col-md-2 mb-3 d-flex align-items-center justify-content-end">
                      <button   type="button"
                  data-bs-dismiss="offcanvas" className="btn btn-primary">Listen</button>
                    </div>
                  </div>
                </div>
              )}

              {/* Buttons */}
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setOpenModal(true)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* /Edit User */}

        {/* Delete Lead */}
        <div className="modal fade" id="delete_lead" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Remove Audio?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br /> Audio you selected.
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete it
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Lead */}
      </>
    </>
  );
};

export default VoiceRinglessTemplate;
